import { writable } from "svelte/store";

const mobileStore = () => {
    const { subscribe, set } = writable(false);
    return { subscribe, set };
};

export const mobile = mobileStore();
